import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { companyInfo } from '../mockData';

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      {/* Elegant Wave Patterns */}
      <div className="absolute inset-0 opacity-30">
        <svg className="absolute w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="wave" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M0 50 Q 25 30, 50 50 T 100 50" stroke="#10B981" strokeWidth="1" fill="none" opacity="0.2"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#wave)" />
        </svg>
      </div>

      {/* Floating Orbs */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-emerald-300 rounded-full opacity-10 blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-teal-300 rounded-full opacity-10 blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

      {/* Content - Elegant Centered Layout */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        {/* Elegant Badge */}
        <div className="inline-flex items-center space-x-2 bg-white border-2 border-emerald-200 rounded-full px-6 py-3 mb-8 shadow-lg">
          <Sparkles size={18} className="text-emerald-600" />
          <span className="text-emerald-700 font-bold text-sm uppercase tracking-wider">Premium Fulfillment</span>
        </div>

        {/* Elegant Typography */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-gray-900 mb-8 leading-none">
          Elevate Your
          <span className="block mt-3 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-700 bg-clip-text text-transparent">
            Ecommerce Excellence
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
          <span className="font-semibold text-emerald-700">{companyInfo.displayName}</span> delivers world-class fulfillment solutions that help your business thrive.
        </p>

        {/* Elegant CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <Link
            to="/contact"
            className="group bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-10 py-5 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center space-x-2"
          >
            <span>Get Free Quote</span>
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/services"
            className="bg-white border-2 border-emerald-600 text-emerald-700 px-10 py-5 rounded-full font-bold text-lg hover:bg-emerald-50 transition-all duration-300"
          >
            Explore Services
          </Link>
        </div>

        {/* Elegant Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-6 text-gray-600">
          <div className="flex items-center space-x-2 bg-white rounded-full px-5 py-3 shadow-md">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-semibold">Fast Processing</span>
          </div>
          <div className="flex items-center space-x-2 bg-white rounded-full px-5 py-3 shadow-md">
            <div className="w-2 h-2 bg-teal-500 rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
            <span className="text-sm font-semibold">Quality Guaranteed</span>
          </div>
          <div className="flex items-center space-x-2 bg-white rounded-full px-5 py-3 shadow-md">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
            <span className="text-sm font-semibold">Expert Support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
